import React from "react";

// Import your images here (adjust paths based on your folder structure)
import smartProducts from "../../../Assets/images/home/ai-banner-img/genrative-gif-new.gif";
import Genrative from "../../../Assets/images/home/ai-banner-img/smart-product-gif.gif";
import CreateImg from "../../../Assets/images/home/ai-banner-img/create-img-gif.gif";
import Slider from "react-slick";
import { Col, Container, Image, Row } from "react-bootstrap";

// const AIFeaturesBuiltforJewelryRetailer = [
//     {
//         icon: MetaTitleIcon,
//         title: "Meta Title",
//         description: "Engaging and keyword rich titles.",
//     },
//     {
//         icon: MetaDescriptionIcon,
//         title: "Meta Description",
//         description: "SEO-friendly short product summaries to boost your click through rates.",
//     },
//     {
//         icon: MetaKeywordsIcon,
//         title: "Meta Keywords",
//         description: "Relevant keywords to help your product top the search results",
//     },
// ];
// const settingsSeo = {
//     dots: true,
//     infinite: true,
//     autoplay: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 3,
//     initialSlide: 0,
//     responsive: [
//         {
//             breakpoint: 1024,
//             settings: {
//                 slidesToShow: 3,
//                 slidesToScroll: 3,
//                 infinite: true,
//                 dots: true
//             }
//         },
//         {
//             breakpoint: 600,
//             settings: {
//                 slidesToShow: 2,
//                 slidesToScroll: 2,
//                 initialSlide: 2
//             }
//         },
//         {
//             breakpoint: 480,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1
//             }
//         }
//     ]
// };

const AIFeaturesBuiltforJewelryRetailer = () => {
    return (
        <section className="powered_features_built_for_jewelry_section">
            <Container className="bw_custome_footer_container ">
                <Row>
                    <Col>
                        <h2 className="Power_AI_headings text-white">
                            AI Features Built for Jewelry Retailers
                        </h2>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={7} lg={7}>
                        <div className="gif_gif_section_left">
                            <Image src={smartProducts} alt="smartProducts" className="img-fluid" />
                        </div>
                    </Col>
                    <Col sm={12} md={5} lg={5} className="d-flex align-items-center">
                        <div className="gif_text_section_right">
                            <h3>Smarter Product Tittle &
                                Descriptions in Seconds</h3>
                            <p>Create professional product photos with our
                                AI-enabled image editing tool. Instantly generate,
                                match, or remove the background of your existing
                                product images using just a few clicks or keywords.</p>
                        </div>
                    </Col>
                </Row>
                <Row>

                    <Col sm={12} md={5} lg={5} className="d-flex align-items-center order-md-1 order-lg-1 order-2 order-sm-2">
                        <div className="gif_text_section_right">
                            <h3>Generate SEO-Optimized
                                Meta Titles, Descriptions and
                                Keywords with Ai</h3>
                            <p>Boost your website’s visibility on search engines
                                with AI-powered meta content generation. Instantly
                                create relevant and optimized meta titles, keywords,
                                and descriptions.</p>
                        </div>
                    </Col>
                    <Col sm={12} md={7} lg={7} className="order-md-2 order-lg-2 order-1 order-sm-1">
                        <div className="gif_gif_section_left">
                            <Image src={Genrative} alt="smartProducts" className="img-fluid" />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={7} lg={7}>
                        <div className="gif_gif_section_left">
                            <Image src={CreateImg} alt="smartProducts" className="img-fluid" />
                        </div>
                    </Col>
                    <Col sm={12} md={5} lg={5} className="d-flex align-items-center">
                        <div className="gif_text_section_right">
                            <h3>Create Stunning
                                Images Instantly.</h3>
                            <p>Generate high-quality images from text prompts
                                using our AI-powered tool—perfect for designers,
                                marketers, and creatives.</p>
                        </div>
                    </Col>
                </Row>


                {/* <Row>
                    <Col sm={12} md={12} lg={12}>
                        <Slider {...settingsSeo} className="powered_ai_seo_slider">
                            {seoFeatures.map((feature, index) => (
                                <div className="powered_ai_seo_slider_outer">
 <div key={index} className="flex flex-col items-center text-center">
                                    <div className="text-center">
                                        <img src={feature.icon} alt={feature.title} className="w-8 h-8" />
                                    </div>
                                    <h3 className="font-semibold mb-2">{feature.title}</h3>
                                    <p className="text-gray-600 text-sm text-center max-w-xs">
                                        {feature.description}
                                    </p>
                                </div>
                                </div>
                               
                            ))}

                        </Slider>
                    </Col>
                </Row> */}
            </Container>

        </section>
    );
};

export default AIFeaturesBuiltforJewelryRetailer;